import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { DashboardComponent } from './pages/dashboard/dashboard.component';
import { AuthGuard } from '../auth/auth.guard';
import { MasterComponent } from '../layout/pages/master/master.component';
import { DashboardGuard } from './dashboard.guard';

const routes: Routes = [
  {
    path: 'dashboard',
    component: MasterComponent,
    canActivate: [AuthGuard, DashboardGuard],
    data: {
      showHeader: true
    },
    children: [
      {
        path: '',
        component: DashboardComponent
      }
    ]
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class DashboardRoutingModule { }
